import { DEFAULT_CUSTOMIZATION } from "./constants";
import {
  Accessory,
  Backdrop,
  Effect,
  GraphicCustomization,
  Hackpal,
  HeaderTextOption,
} from "./types";

const RANDOM_BACKDROPS = [
  Backdrop.NIGHTTIME,
  Backdrop.FOREST,
  Backdrop.MOUNTAINS,
] as const;

const RANDOM_HACKPALS = [Hackpal.GINNY, Hackpal.PATCH, Hackpal.VINYL] as const;

const RANDOM_ACCESSORIES = [
  Accessory.INSTRUMENT,
  Accessory.PLANT,
  Accessory.WRENCH,
] as const;

const RANDOM_EFFECTS = [
  Effect.EXCITEMENT,
  Effect.MUSIC,
  Effect.SPARKLES,
] as const;

const RANDOM_HEADLINES = [
  HeaderTextOption.IM_GOING,
  HeaderTextOption.SEE_YOU,
] as const;

const selectRandom = <T>(options: readonly T[], random: () => number): T =>
  options[Math.floor(random() * options.length)];

export const createRandomDefaultCustomization = (
  random: () => number = Math.random
): GraphicCustomization => ({
  ...DEFAULT_CUSTOMIZATION,
  backdrop: selectRandom(RANDOM_BACKDROPS, random),
  hackpal: selectRandom(RANDOM_HACKPALS, random),
  accessory: selectRandom(RANDOM_ACCESSORIES, random),
  effect: selectRandom(RANDOM_EFFECTS, random),
  headerText: selectRandom(RANDOM_HEADLINES, random),
});
